export default __webpack_public_path__ + "static/media/stripe.bfead765.svg";